import React from 'react';
import * as utils from "../utils";

class SummaryError extends React.Component {


    render() {

        function getClasses(errorCode) {
            if (errorCode === '4100') {
                return "container col-md-8 padding-bottom-5";
            }
            else {
                return "container col-md-12 padding-bottom-5";
            }
        }


        return <div className="row">
            <div className={getClasses(this.props.data.errorCode)}>
                <div id="name" className="name">{this.props.data.summary.name}</div>
                <div id="customerId">Fødselsnr.:{utils.formatSsn(this.props.data.summary.customerId)}</div>
            </div>
        </div>
    }
}

export default SummaryError;